import React from "react";

const HealthTopics = () => {
  return <div>Health topics</div>;
};

export default HealthTopics;
